/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenWithSecret
 */
export interface APITokenWithSecret {
    /**
     * 
     * @type {number}
     * @memberof APITokenWithSecret
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof APITokenWithSecret
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof APITokenWithSecret
     */
    name: string;
}

export function APITokenWithSecretFromJSON(json: any): APITokenWithSecret {
    return APITokenWithSecretFromJSONTyped(json, false);
}

export function APITokenWithSecretFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenWithSecret {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'name': json['name'],
    };
}

export function APITokenWithSecretToJSON(value?: APITokenWithSecret | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'token': value.token,
        'name': value.name,
    };
}


